import store from '../store/index'

export default function() {
  let http = store.getters.getHttp;
  if (store.getters.getUser.hasOwnProperty("token")) {
    console.log("trying to set headers");
    http.defaults.headers.common["authorization"] =  "Bearer " + store.getters.getUser.token

  }
  return http;

}